































import { Component, Vue } from 'vue-property-decorator'
import AccountIdInput from '@/components/ui/AccountIdInput.vue'
import requests from '@/helpers/requests'
import TechTaskCard from '@/components/ui/TechTaskCard.vue'


interface RequestPayload {
    pulsemAccountId: number|null;
}


interface Settings {
    id: number;
    active: 0|1;
    apiKey: {
        apiKey: string;
    };
    settings: {
        _pulsemAccountId: number;
    };
}


interface LoadData {
    settings: Settings;
}


interface LoadResponse {
    data: {
        settings: Settings|null;
    };
    message: string;
    status: number;
}


@Component({
    components: {
        AccountIdInput,
        TechTaskCard
    }
})
export default class SetupSuccessWareIntegration extends Vue {
    locationValid = false
    loadingInformation = false
    loadInformationErrorMessage: string|null = null
    pulsemAccountId: number|null = null
    apiKey: string|null = null

    get requestPayload(): RequestPayload {
        return {
            pulsemAccountId: this.pulsemAccountId
        }
    }

    async onLocationChange(locationValid: boolean) {
        this.loadInformationErrorMessage = null
        if (locationValid) {
            this.loadingInformation = true
            this.apiKey = null
            try {
                const response = await requests.post('/support/zapier/load-integration', {
                    pulsemAccountId: this.pulsemAccountId
                }) as LoadResponse
                this.apiKey = response.data.settings?.apiKey.apiKey || null
                this.locationValid = locationValid
            } catch(e) {
                this.loadInformationErrorMessage = e.message
                this.locationValid = false
            }
            this.loadingInformation = false
        } else {
            this.locationValid = false
            this.loadingInformation = false
        }
    }

    onSubmit() {
        this.onLocationChange(this.locationValid)
    }

    get canCreate() {
        return Boolean(!this.apiKey && this.locationValid)
    }
}
